import request from '@/utils/request'

// 获取班组列表
export const getTeamLists = (data) => {
    return request({
        url: '/workgroup/lists',
        params: data
    })
}

// 班组-详情
export const getTeamDetail = (id) => {
    return request({
        url: `/workgroup/${id}`
    })
}

// 班组-修改
export const putTeam = (data) => {
    return request({
        url: `/workgroup/${data.id}`,
        method: 'PUT',
        data: data.data
    })
}

// 班组-添加
export const addTeam = (data) => {
    return request({
        url: '/workgroup/manage',
        method: 'POST',
        data
    })
}

// 班组-删除
export const delTeam = (id) => {
    return request({
        url: `/workgroup/${id}`,
        method: 'DELETE'
    })
}
